import type { IClient, IClientContact } from '@/interfaces'
import { Client, ClientIndex } from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { APIEndpoints, APIScopes, APIURL } from '@/services/API'
export interface ICardCode {
	CardCode: string
}
export class ClientService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}
	async getIndex(params?: object): Promise<ClientIndex[]> {
		return this.getData<ClientIndex[]>(`${APIEndpoints.client}/`, params)
			.then((data) => {
				return data.map((c: ClientIndex) => new ClientIndex(c))
			})
			.catch((err) => {
				throw err
			})
	}
	async get(id: string): Promise<Client> {
		return this.getData<Client>(`${APIEndpoints.client}/${id}`)
			.then((data) => {
				return new Client(data)
			})
			.catch((err) => {
				throw err
			})
	}
	async delete(id: string): Promise<boolean> {
		return this.deleteData<boolean>(`${APIEndpoints.client}/${id}`)
			.then((data) => {
				return data
			})
			.catch((err) => {
				throw err
			})
	}
	async getCode(name: string): Promise<string> {
		const params = new URLSearchParams()
		params.append('name', name)
		return this.getData<string>(`${APIEndpoints.client}/code`, params)
			.then((data) => {
				return data
			})
			.catch((err) => {
				throw err
			})
	}
	async add(client: Client): Promise<Client> {
		const obj = client
		return this.postData<Client, Client>(`${APIEndpoints.client}/add`, obj)
			.then((res) => {
				return res as Client
			})
			.catch((err) => {
				throw err
			})
	}
	async update(client: Client): Promise<Client> {
		const obj = client.toJSON()
		return this.patchData<string, Client>(`${APIEndpoints.client}/update`, obj)
			.then((data) => {
				return new Client(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async getClientContacts(id: string): Promise<IClientContact[]> {
		return this.getData<IClientContact[]>(`${APIEndpoints.client}/${id}/contacts`)
			.then((data) => {
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	async getClientBySubJobId(subjobId: string | number): Promise<Client> {
		return this.getData<IClient>(`${APIEndpoints.client}/by-subjob-id/${subjobId}`)
			.then((data) => {
				return new Client(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async getClientByQuoteId(quoteId: string | number): Promise<Client> {
		return this.getData<IClient>(`${APIEndpoints.client}/by-quote-id/${quoteId}`)
			.then((data) => {
				return new Client(data)
			})
			.catch((err) => {
				throw err
			})
	}
}
